module.exports = __webpack_public_path__ + "public/images/slider/speaker-10.a97f43a2eccd70252749d9956a9b2237.jpg";